var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intelligence-kpis"},_vm._l((_vm.cards),function(card){return _c('div',{key:card.key,staticClass:"intelligence-kpis__card"},[_c('p',{staticClass:"intelligence-kpis__label"},[_vm._v(_vm._s(card.label))]),_c('p',{staticClass:"intelligence-kpis__value"},[_vm._v(_vm._s(card.displayValue))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }